import { render, staticRenderFns } from "./InvestHistory.vue?vue&type=template&id=2cd9ae28&scoped=true&"
import script from "./InvestHistory.vue?vue&type=script&lang=js&"
export * from "./InvestHistory.vue?vue&type=script&lang=js&"
import style0 from "./InvestHistory.vue?vue&type=style&index=0&id=2cd9ae28&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd9ae28",
  null
  
)

export default component.exports